export enum EnumTipoConfiguracion {
  Widget = 1,
  Plantilla = 2
}
